import { format } from 'date-fns';
import { atom } from 'jotai';

export const stateAtom = atom({
  boundary: null,
  query: {},
  parameters: {},
});

export const columns = [
  {
    header: 'Registration',
    id: 'properties.vehicle.registrationNumber',
    accessorFn: ({
      properties: { vehicle: { registrationNumber } = {} } = {},
    } = {}) => registrationNumber ?? '',
  },
  {
    header: 'Fleet Number',
    id: 'properties.vehicle.fleetNumber',
    accessorFn: ({ properties: { vehicle: { fleetNumber } = {} } = {} } = {}) =>
      fleetNumber ?? '',
  },
  {
    header: 'Role',
    id: 'properties.vehicle.role',
    accessorFn: ({ properties: { vehicle: { role } = {} } = {} } = {}) =>
      role ?? '',
  },
  {
    header: 'Type',
    id: 'properties.vehicle.type',
    accessorFn: ({ properties: { vehicle: { type } = {} } = {} } = {}) =>
      type ?? '',
  },
  {
    header: 'IMEI',
    id: 'properties.imei',
    accessorFn: ({ properties: { imei } = {} } = {}) => imei ?? '',
  },
  {
    header: 'Time',
    accessorKey: 'properties.time',
    Cell: ({ cell }) => format(cell.getValue(), 'dd/MM/yyyy HH:mm:ss'),
  },
  {
    header: 'Speed',
    id: 'properties.speedMilesPerHour',
    accessorFn: ({ properties: { speedMilesPerHour } = {} } = {}) =>
      speedMilesPerHour ? `${speedMilesPerHour} MPH` : '',
  },
  {
    header: 'Longitude',
    id: 'geometry.coordinates.0',
    accessorFn: ({ geometry: { coordinates: [longitude] = [] } = {} } = {}) =>
      longitude ?? '',
  },
  {
    header: 'Latitude',
    id: 'geometry.coordinates.1',
    accessorFn: ({ geometry: { coordinates: [_, latitude] = [] } = {} } = {}) =>
      latitude ?? '',
  },
];
